import { SearchItemType, FileType, SelectedDocumentType } from "./enums";

export interface SelectedItem {
    arrayName: string;
    nestedKey: string;
    nestedValue: unknown;
}

export interface TreeNode {
    name: string;
    checked?: 0 | 0.5 | 1;
    isOpen?: boolean;
    children?: TreeNode[];
}

export interface IVideoText {
    subtitles: ISubtitle[];
}
export interface ISubtitle {
    text: string;
    t0: number;
    t1: number;
    guid: string;
}

export interface IKorraEvent {
    workspaceId: string;
    kappId: string;
    portalId: string;
    userAgent: string;
    platform: string;
    userId: string | null;
    eventType: IKorraEventType;
    eventDoc: IKorraEventDoc;
    guid: string;

}
export enum IKorraEventType {
    resultClick = "resultClick",
    referenceClick = "referenceClick",
    question = "question",
    portalQuestion = "portalQuestion",
    bounce = "bounce", // ?
    pdfRead = "pdfRead",
    videoPlay = "videoPlay",
    searchAnswer = "searchAnswer",
    searchAnswerNoResults = "searchAnswerNoResults",
    thumbsUp = "thumbsUp",
    thumbsDown = "thumbsDown",
    SearchResultThumbsUp = "searchResultThumbsUp",
    SearchResultThumbsDown = "searchResultThumbsDown"
}
export interface IKorraEventDoc {
    question: string;
    answerText: string;
    answerLink: string;
    fileName: string;
    fileType: FileType | string;
    seconds: number;
    ranking: number;
    docGuid: string;
    srcUrl: string;
}

export interface IbgImage {
    background: string;
    logo: string;
    href: string;
}

export interface IVideoText {
    subtitles: ISubtitle[];
}
export interface ISubtitle {
    text: string;
    t0: number;
    t1: number;
    guid: string;
}

export interface IQuestionForExample {
    text: string;
    href: string;
}

export interface Theme {
    name: "preview" | "publish";
    bgImage: string;
    logoImage: string;
    bgPortraitImage: string;
    imageLayout: "cover" | "full";
    logoUrl: string;
    questionsForExample: QuestionForExample[];
    contactUsDestinationLink: string;
    contactUsDestinationMessage: string;
    fileRepositoryDestinationLink: string;
    enableQuestionsForExample: boolean;
    enableContactUsDestinationLink: boolean;
    enableFileRepositoryDestinationLink: boolean;
    disableFilters: boolean;
    explanator: boolean;
    searchBarPlaceHolder: string;
    isPrivate: boolean;
    highlightPdf: boolean;
    documentWatermark: boolean;
    hideFileName: boolean;
    showManyHeaders: boolean;
    max_per_subject: number;
    specialFeatures: string;
    rtlenabled?: boolean;
    yearRangeEnabled?: boolean;
    enableArticlesLibrary: boolean;
    enableUpdatedArticles: boolean;
    updatedArticlesExpireListCount: number | null;
    refineResults: boolean;
    vettedResults: boolean;
    showRelatedDocuments: boolean;
    showKeywordFilter: boolean;
    mediaTypeClientSideFiltering: boolean;
    filtersType: string;
    showHomePageFilter: boolean;
    activeLogger: boolean;
    showFilePath: boolean;
    tagMessageMap: { [key: string]: string };
    enableKeywordToggle: boolean;
}

export interface QuestionForExample {
    text: string;
    href: string;
}

export interface SelectedFilters {
    selectedDocumentType: SelectedDocumentType;
    selectedKapps: string[];
    selectedTags: string[];
}

export interface IUser {
    email: string;
    id: string;
    firstName: string;
    lastName: string;
    name: string;
    userIdToken?: string; //token with userId only cliams
    secondEmail?: string;
    phone?: string;
}

export interface UpdateUserRequest {
    workspaceId: string;
    userId: string;
    secondEmail?: string;
    phone?: string;
}

export interface Settings {
    companyName?: string;
    website?: string;
    country?: string;
}

export interface IWorkspace {
    id: string;
    name: string;
    settings?: Settings;
    token?: string; //token with userId and workspaceId cliams
}

export interface UpdateWorkspaceSettingsRequest {
    companyName: string;
    website: string;
    country: string;
    workspaceId: string;
    userId: string;
}

export interface IUserWorkspace {
    userId: string;
    userFirstName: string;
    userLastName: string;
    userName: string;
    userEmail: string;
    workspaceId: string;
    workspaceName: string;
    workspaces?: string[]; //participent in workspaces
    token?: string; //token with userId and workspaceId cliams
    isKorraUser?: boolean;
}
export interface Summary {
    text: string;
    type: string;
    sources: Source[];
    style: string;
    error: string;
    resultDone: boolean
}
export interface SearchResultType {
    ai: string;
    sources: Source[];
    error: string;
    loading: boolean;
    human: string
}
export interface Source {
    url: string;
    details: string;
    type: SearchItemType;
    startCell: any;
    pageNumber: any;
    tstart: any;
}

export interface Tag {
    workspaceId: string;
    kappId: string;
    docGuid: string;
    value: string;
    // UI
    selected: boolean;
}

export interface Library {
    id: string;
    name: string;
    kappId: string;

    documentsCount?: number;
    documents?: Document[];
}

export interface Document {
    fileUri: string;
    originalFileUri: string;
    docGuid: string;
    size: number;
    creationTime: string;
    fileType: FileType;
    uploadUid?: string;
    isReProcess?: boolean;
    language?: string;
    tags?: string[];

    // UI
    error: string;
}

export interface GetFirstGuidResponse {
    guid: string;
    page: number;
}

export interface StartSessionResponse {
    sessionId: string;
    toExpireTime: string;
}



export interface PingSessionResponse {
    sessionId: string;
    toExpireTime: string;
}

export interface IResponse<T> {
    data: T;
    error?: IResponseError;
}


export interface IResponseError {
    code: number;
    message: string;
}

export interface PortalItem {
    id: string;
    name: string;
    workspaceId: string;
    lastModified: string;
    creationTime: string;
    mode: string;
    chatThemes: ChatThemeItem[];
    themes: ThemeItem[];
}

export interface ChatThemeItem {
    name: "preview" | "publish";
    backgroundImage: string;
    logoImage: string;
    avatar: string;
    persona: string;
    unit: string;
    height: string;
    location: string;
    frameHex: string;
    isPrivate: boolean;
    fileRepositoryDestinationLink: string;
    enableFileRepositoryDestinationLink: boolean;
    rtlenabled: boolean;
    activeLogger: boolean;
}

export interface ThemeItem {
    name: "preview" | "publish";
    bgImage: string;
    logoImage: string;
    bgPortraitImage: string;
    imageLayout: "cover" | "full";
    logoUrl: string;
    questionsForExample: QuestionForExample[];

    contactUsDestinationLink: string;
    fileRepositoryDestinationLink: string;

    enableQuestionsForExample: boolean;
    enableContactUsDestinationLink: boolean;
    enableFileRepositoryDestinationLink: boolean;
    disableFilters: boolean;

    explanator: boolean;

    searchBarPlaceHolder: string;

    isPrivate: boolean;
    highlightPdf: boolean;

    hideFileName: boolean;
    showManyHeaders: boolean;
    max_per_subject: number;
    specialFeatures: string;
    rtlenabled: boolean;

    enableArticlesLibrary: boolean;
    enableUpdatedArticles: boolean;
    updatedArticlesExpireListCount: number;
    activeLogger: boolean;
}

export interface EdgeUser {
    workspaceId: string;
    email: string;
    password: string;
    id: string;
    firstName: string;
    lastName: string;
    name: string;
    isReseted: boolean;
    workspaces?: string[];//participent in workspaces
    userIdToken?: string;//token with userId only cliams
    secondEmail?: string;
    phone?: string;
}

export interface StoredEdgeUser {
    user: EdgeUser;
    workspaceId: string;
    timestamp: number; // Unix timestamp in milliseconds
}